import React from "react";
import { SharedMember } from "../../services/projectMonitoring";

// Warning body for the bulk "Disable all" confirm: monitoring is per-polygon
// (one flag per map_id, shared across every project it belongs to), so disabling
// members that also live in other projects turns them off there too.
const SharedProjectsWarning: React.FC<{ shared: SharedMember[] }> = ({ shared }) => {
  if (!shared.length) return null;
  return (
    <div className="mt-3 rounded-lg border border-warn-line bg-warn-soft p-3 text-warn-ink">
      <p className="font-medium">Some areas are also in other projects:</p>
      <ul className="mt-1 list-disc pl-5">
        {shared.map((s) => (
          <li key={s.id}>
            {s.name} — also in {s.otherProjects.join(", ")}
          </li>
        ))}
      </ul>
      <p className="mt-2">Disabling here turns monitoring off there too.</p>
    </div>
  );
};

export default SharedProjectsWarning;
